import React from 'react';
import { Col, Container, Row, Card, CardBody } from 'reactstrap';
import ReportCardsContainer from '../ReportCardsContainer';
import AgentsCardsContainer from '../AgentsCardsContainer';
import PendingDialerTable from '../Report';
import SuccessFailureProgressBar from 'components/FlexSuccessFailureProgressBar';
import LastDialersTable from '../Report/last';

/**
 * MainContainer component renders the main dashboard view.
 *
 * @param {Object} props - The component props.
 * @param {Object} props.data - The data object containing information for the dashboard.
 * @param {Array} props.data.pendingDialer - Array of pending dialer objects.
 * @param {string} props.data.NewDialerName - The name of the new dialer.
 * @param {Array} props.data.agents - Array of agent objects.
 * @param {Array} props.data.lastDialers - Array of last dialer objects.
 *
 * @returns {JSX.Element} The rendered MainContainer component.
 */

const MainContainer = ({ data }) => {
  const totalCount =
    data.pendingDialer.length > 0 ? Number(data.pendingDialer[0].count) : 0;

  const allSuccessCount = data.pendingDialer.reduce((acc, pd) => {
    return acc + Number(pd.sucesso);
  }, 0);

  return (
    <div style={{ position: 'relative', overflowX: 'hidden' }}>
      <Container fluid style={{ padding: '0', marginTop: '-1rem' }}>
        <Row style={{ padding: '0' }}>
          <div className="col" style={{ padding: '0' }}>
            <Card style={{ padding: '0' }}>
              <CardBody>
                <Row>
                  <Col md="4">
                    <ReportCardsContainer data={data} />
                  </Col>
                  <Col md="8">
                    <AgentsCardsContainer
                      dialerName={data.NewDialerName}
                      agents={data.agents}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md="12">
                    <p>Tentativas:</p>
                    <PendingDialerTable data={data.pendingDialer} />
                  </Col>
                </Row>
                <Row>
                  <Col md="12">
                    <p>Visão geral de sucesso:</p>
                    <SuccessFailureProgressBar
                      insucesso={0}
                      sucesso={allSuccessCount}
                      count={totalCount}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md="12">
                    <p style={{ marginTop: '1rem' }}>Últimas discagens:</p>
                    <LastDialersTable data={data.lastDialers} />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </div>
        </Row>
      </Container>
    </div>
  );
};

export default MainContainer;
